<div class="col-12">
    <div class="alert alert-success" [hidden]="!resetSuccess">
        {{ 'auth.reset-password.success' | translate }}
    </div>

    <form class="login-form"
          [formGroup]="form"
          (ngSubmit)="submit()"
          [hidden]="resetSuccess">
        <div class="title">
            <span class="text">{{ 'auth.reset-password.title' | translate }}</span>
        </div>

        <div class="subtitle">
            <span class="text">{{ 'auth.reset-password.subtitle' | translate }}</span>
        </div>

        <div class="alert alert-danger" [hidden]="!resetError">
            {{ 'auth.reset-password.error' | translate }}
        </div>

        <cap-input formControlName="email"
                   [label]="'auth.sign-in.email' | translate"
                   [placeholder]="'auth.sign-in.email' | translate">
        </cap-input>

        <cap-input formControlName="password"
                   type="password"
                   [label]="'auth.reset-password.password' | translate"
                   [placeholder]="'auth.reset-password.password' | translate">
        </cap-input>

        <cap-input formControlName="password_confirmation"
                   type="password"
                   [label]="'auth.reset-password.confirm-password' | translate"
                   [placeholder]="'auth.reset-password.confirm-password' | translate">
        </cap-input>

        <div class="flex-buttons">
            <cap-button type="button"
                        routerLink="/auth/login"
                        styleClass="secondary"
                        [label]="'auth.forgot-password.button.back' | translate">
            </cap-button>

            <cap-button type="submit"
                        styleClass="primary"
                        [label]="'auth.reset-password.submit' | translate">
            </cap-button>
        </div>
    </form>
</div>
